import { BaseXHR } from 'utils/axios';
export const getLOVPaymentMethodReservation = async () => {
    return BaseXHR.$get('/b2b/reservation/v2/booking/method-listing');
}